export default __webpack_public_path__ + "assets/tkoFirstLight.f389eaa5.png";